import { render, staticRenderFns } from "./OrderAtmosphere.vue?vue&type=template&id=ff72841a&scoped=true&"
import script from "./OrderAtmosphere.vue?vue&type=script&lang=js&"
export * from "./OrderAtmosphere.vue?vue&type=script&lang=js&"
import style0 from "./OrderAtmosphere.vue?vue&type=style&index=0&id=ff72841a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff72841a",
  null
  
)

export default component.exports